/* import __COLOCATED_TEMPLATE__ from './reviewable-post-header.hbs'; */
import Component from "@ember/component";

export default class ReviewablePostHeader extends Component {}
